import { EShipmentTypes } from 'services/shipments/types/shipments.types';

export const isFoodShipment = (shipmentType: string) =>
  shipmentType === EShipmentTypes.STANDARD_FOOD;

export const isNonFoodShipment = (shipmentType: string) =>
  shipmentType === EShipmentTypes.STANDARD_NONFOOD;

export const isExpressShipment = (shipmentType: string) => shipmentType === EShipmentTypes.EXPRESS;

export const isMKPShipment = (shipmentType: string) => shipmentType === EShipmentTypes.MARKETPLACE;
